import { CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_SUCCESS } from './../const';

function action(data, successCallback) {
  return { type: CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_SUCCESS, data, successCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyMailUnsubscribeSuccess.js